import React from 'react';
import { useAdmin } from '../../contexts/AdminContext';

const AdminDashboard: React.FC = () => {
  const { adminUser } = useAdmin();

  return (
    <div style={{ padding: 24 }}>
      <h2>Admin Console</h2>
      <p>Welcome, {adminUser?.name || adminUser?.email}</p>
      <p>From here you can manage document types, field types, templates, resources, guides and news posts.</p>
    </div>
  );
};

export default AdminDashboard;
